<div [hidden]="isHidden">
  @if (control.name) {
    @switch (control.type) {
      @case (formType.repeat) {
        <air-repeat-control
          [group]="group"
          [control]="control"
          [formState]="formState"
          [ngClass]="{ grid: repeatControl.fullWidth === false }"
          [showMandatory]="showMandatory"
          [userEventSource]="userEventSource"
        ></air-repeat-control>
      }
      @case (formType.checkbox) {
        <air-checkbox-control
          [group]="group"
          [control]="control"
          [formState]="formState"
          [userEventSource]="userEventSource"
        ></air-checkbox-control>
      }
      @default {
        <ng-container *ngTemplateOutlet="formControlTemplate"></ng-container>
      }
    }
    @if (control.type !== formType.repeat && control.hasError && control.errorMessages?.length) {
      <div class="form-error">
        @for (message of control.errorMessages; track message) {
          <div class="form-error__message">
            {{ message }}
          </div>
        }
      </div>
    }
    @if (control.type !== formType.repeat && control.hasError && control.htmlErrorMessages?.length) {
      @for (message of control.htmlErrorMessages; track message) {
        <div class="form-message" [internalInnerHtml]="message"></div>
      }
    }
    @if (checkCardStatusError?.error) {
      <p class="form-message--card-status">
        @switch (checkCardStatusError?.response) {
          @case (cardStatus.hasAccount) {
            {{ 'account.error.card_number.has_account' | translate }}
            <button type="button" class="button-link" (click)="openLoginModal()">{{ 'account.error.login' | translate }}</button>
            {{ 'account.error.or' | translate }}
            <button type="button" class="button-link" (click)="openPrefilledPasswordResetModal(formValidatorTypeKeys.checkCardStatus)">
              {{ 'account.error.reset_your_password' | translate }}
            </button>
            .
          }
          @case (cardStatus.notFound) {
            <span class="form-error">{{ 'account.error.card_number.not_found' | translate }}</span>
          }
          @case (cardStatus.blocked) {
            <span class="form-error">{{ 'account.error.card_number.blocked' | translate }}</span>
          }
        }
      </p>
    }
    @if (checkPhoneNumberExistenceError?.error) {
      <p class="form-message--user-exists">
        {{ 'account.error.phone_number.exists_verification' | translate }}
      </p>
    }
    @if (checkUserExistenceError?.error) {
      <p class="form-message--user-exists">
        @if (!isLoggedIn) {
          {{ 'account.error.email.exists' | translate }}
          <button type="button" class="button-link" (click)="openLoginModal()">{{ 'account.error.login' | translate }}</button>
          ,
          <button type="button" class="button-link" (click)="openPrefilledPasswordResetModal(formValidatorTypeKeys.checkUserExistence)">
            {{ 'account.error.reset_your_password' | translate }}
          </button>
          {{ 'account.error.or' | translate }} {{ 'account.error.use_another_email' | translate }}.
        }
        @if (isLoggedIn) {
          {{ 'account.error.email.exists_verification' | translate }}
        }
      </p>
    }
    @if (hasError('passwordLogin')) {
      <p class="form-error">
        {{ 'account.error.password.invalid_login' | translate }}
        <button type="button" class="button-link" (click)="openPasswordResetModal()">
          {{ 'account.error.reset_your_password' | translate }}
        </button>
      </p>
    }
  }
</div>

@if (!isHidden || control.showOnlyDescription) {
  @if (control.description && !control.textOnlyDescription) {
    <div class="form__description" [internalInnerHtml]="control.description" [userEventSource]="userEventSource"></div>
  }
  @if (control.description && control.textOnlyDescription) {
    <small class="form__description" [internalInnerHtml]="control.description" [userEventSource]="userEventSource"></small>
  }
}

<ng-template #formControlTemplate>
  <div class="form-group">
    @if (control.label) {
      <label
        [for]="control.name"
        [ngClass]="{
          'form-label--error': control.hasError
        }"
      >
        {{ control.label }}
        @if (showMandatory) {
          <span>*</span>
        }
      </label>
    }
    @switch (control.type) {
      @case (formType.radio) {
        <air-radio-control
          [group]="group"
          [control]="control"
          [formState]="formState"
          [userEventSource]="userEventSource"
        ></air-radio-control>
      }
      @case (formType.select) {
        <air-select-control [group]="group" [control]="control" [formState]="formState"></air-select-control>
      }
      @case (formType.password) {
        <air-password-control [group]="group" [control]="control" [formState]="formState"></air-password-control>
      }
      @case (formType.textarea) {
        <air-textarea-control [group]="group" [control]="control" [formState]="formState"></air-textarea-control>
      }
      @case (formType.numeric) {
        <air-numeric-control [group]="group" [control]="control" [formState]="formState"></air-numeric-control>
      }
      @case (formType.file) {
        <air-file-control
          [group]="group"
          [control]="control"
          [formState]="formState"
          [userEventSource]="userEventSource"
          (files)="setFiles($event)"
          (busy)="setFilesBusy($event)"
        ></air-file-control>
      }
      @default {
        <air-text-control
          [group]="group"
          [control]="control"
          [formState]="formState"
          [userEventSource]="userEventSource"
        ></air-text-control>
      }
    }
  </div>
</ng-template>
